import methods from '@/enums/methods'
import ThothV2 from '../base/thothV2'

class CreditAnalysisService extends ThothV2 {
  create(payload) {
    return this.fetch({
      url: '/pre-credit-analysis/new',
      method: methods.POST,
      data: payload
    })
  }

  getAwaitingValidation() {
    return this.fetch({
      url: '/pre-credit-analysis/awaiting-validation',
      method: methods.GET
    })
  }

  validate(payload) {
    return this.fetch({
      url: '/pre-credit-analysis/validate',
      method: methods.POST,
      data: payload
    })
  }

  importFile(payload) {
    return this.fetch({
      url: '/pre-credit-analysis/validate/import-file',
      method: methods.POST,
      data: payload
    })
  }

  getDataToPdf(id) {
    return this.fetch({
      url: `/pre-credit-analysis/data-to-pdf/${id}`,
      method: methods.GET,
      responseType: 'blob'
    })
  }
  
  deleteFile(fileId) {
    return this.fetch({
      url: `/pre-credit-analysis/validate/delete-file/${fileId}`,
      method: methods.DELETE
    })
  }

  downloadFile(id) {
    return this.fetch({
      url: `/pre-credit-analysis/validate/download-file/${id}`,
      method: methods.GET
    })
  }

  previewFile(id) {
    return this.fetch({
      url: `/pre-credit-analysis/validate/preview-file/${id}`,
      method: methods.GET
    })
  }

  getAll() {
    return this.fetch({
      url: '/pre-credit-analysis',
      method: methods.GET
    })
  }

  getById(id) {
    return this.fetch({
      url: `/pre-credit-analysis/get-by-id/${id}`,
      method: methods.GET
    })
  }

  reprocessPendingSteps(id) {
    return this.fetch({
      url: '/pre-credit-analysis/execute-steps-error',
      method: methods.POST,
      data: { id: Number(id) }
    })
  }

  getProducts() {
    return this.fetch({
      url: '/pre-credit-analysis/products',
      method: methods.GET
    })
  }

  getParameters(productId) {
    return this.fetch({
      url: `/pre-credit-analysis/parameters/${productId}`,
      method: methods.GET
    })
  }

  updateParameters(payload) {
    return this.fetch({
      url: '/pre-credit-analysis/parameters/update',
      method: methods.PATCH,
      data: payload
    })
  }

  getClientInformation(document) {
    return this.fetch({
      url: `/pre-credit-analysis/client-information/${document}`,
      method: methods.GET
    })
  }

  getHistoryById(id) {
    return this.fetch({
      url: `/pre-credit-analysis/logs/${id}`,
      method: methods.GET
    })
  }
}

export default new CreditAnalysisService()